import BaseModelAPI from '../BaseModelAPI';

export default class ScannerErrorLog extends BaseModelAPI {
	static entity = 'scannererrorlog';
	static entityName = 'scannererrorlog';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.logDate = '';
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.customerId = '';
			this.customer = {};
			this.caseQty = 0;
			this.transactionType = '';
			this.transactionId = 0;
			this.userId = '';
			this.user = {};
			this.errMessage = '';
			this.inputType = '';
			this.inputTypeId = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}